module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAElSURBVHgBrVWBccIwDFQ6QTaoNyibNCO4E+ANSCeADdoNSifICLCB2YARjHS8iM5g7MvxdzonsvR+K7JD9AAppZ4tsP2xxTTjAJ+nVkgw2znVEavEHLA1CRNUOjO/woLRxG1KZBsEiLpA9Z2ENO9k+2ibSraiRkCxkg52QrcQComCkcpKVUxv1UUqKykSYn5CjH/j90/4v2k5/jEOQqg1O9Jy7DF+CKGTp67rFhNy7gmPTuuTniWYRnaVmCQKT3C8P+H8whjR/C4jm8uWrmez2DJZ4mjUeuPXTtnbPpqoAaKO7Zftx/iito3eLOdWlYakx7i+6+MXHT2fT+4MaUs914ZsLAUp6a3wVjHqF8xRE+xqK+f3XQmibqBWgDj/BUT4vH6UHBdZtjxwrIhmDwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clock-icon-white.png
// module id = fbqR
// module chunks = 1